import { MembersPage } from "@icoach/members/";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import { RentCabinetDocumentPageByRead, RentCabinetDocumentPage } from "@icoach/rentCabinet";
import { MemberDetailPage } from "@icoach/memberDetail/";
import SmartFitnessBandContractPage from "@icoach/smartFitnessBand/contract/SmartFitnessBandContractPage";
import SmartFitnessBandContractQuitPage from "@icoach/smartFitnessBand/contract/SmartFitnessBandContractQuitPage";
import { MEMBERS_TABS } from "@icoach/constants/";

// 會員管理
const memberRouter = [
	{
		description: "會員管理",
		frontKey: "C2X01",
	},
	{
		description: "會員總覽",
		strict: true,
		path: CLUB_MEMBERS_ROUTER.MEMBER_OVERVIEW.PAGE,
		href: CLUB_MEMBERS_ROUTER.GET_TABS_PATH(MEMBERS_TABS.MEMBER_OVERVIEW),
		as: MembersPage,
		frontKey: "C2X02",
	},
	{
		description: "租櫃管理",
		strict: true,
		path: CLUB_MEMBERS_ROUTER.CABINET.PAGE,
		href: CLUB_MEMBERS_ROUTER.CABINET.GET_TABS_PATH("document"),
		as: MembersPage,
		frontKey: "C2X06",
	},
	{
		description: "置物櫃承租申請建立",
		exact: true,
		path: CLUB_MEMBERS_ROUTER.CABINET.CONTRACT,
		as: RentCabinetDocumentPage,
		frontKey: "C2X06",
	},
	{
		description: "置物櫃承租申請編輯",
		exact: true,
		path: CLUB_MEMBERS_ROUTER.CABINET.CONTRACT,
		as: RentCabinetDocumentPage,
		frontKey: "C2X06",
	},
	{
		description: "查看置物櫃承租申請",
		exact: true,
		path: CLUB_MEMBERS_ROUTER.CABINET.REVIEW,
		as: RentCabinetDocumentPageByRead,
		frontKey: "C2X06",
	},
	{
		description: "贈品管理",
		exact: true,
		path: CLUB_MEMBERS_ROUTER.GIFT.PAGE,
		href: CLUB_MEMBERS_ROUTER.GIFT.GET_TABS_PATH("overview"),
		as: MembersPage,
		frontKey: "C2X05",
	},
	{
		description: "智能手錶",
		exact: true,
		path: CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.PAGE,
		href: CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.GET_TABS_PATH("overview"),
		as: MembersPage,
		frontKey: "C2X07",
	},
	{
		description: "智能手錶文書新增",
		exact: true,
		path: CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.CONTRACT_PAGE,
		as: SmartFitnessBandContractPage,
		frontKey: "C2X07",
	},
	{
		description: "智能手錶檢視訂閱內容",
		exact: true,
		path: CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.CONTRACT_DETAIL_PAGE,
		as: SmartFitnessBandContractPage,
		frontKey: "C2X07",
	},
	{
		description: "智能手錶文書終止",
		exact: true,
		path: CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.CONTRACT_QUIT_PAGE,
		as: SmartFitnessBandContractQuitPage,
		frontKey: "C2X07",
	},
	{
		description: "會員資訊頁",
		strict: true,
		path: CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.PAGE,
		as: MemberDetailPage,
		frontKey: "C2X03",
	},
];

export default memberRouter;
